import React from 'react';

import { useModalDetails } from 'hb-redux-store/feature/modal/modal.hooks';

import Icon from '../Icon/Icon';

const MultipleSkuDropDown = ({
  product = {},
  sku = {},
  containerStyle = '',
  quantityTextStyle = '',
  productSubTextStyle = '',
  iconSize = 12,
  source = '',
  rightArrow = false,
  showSubtext = false,
}) => {
  const { showMultipleSkuModal } = useModalDetails();
  const hasMultipleSku = product?.skus?.length > 1;
  return (
    <div
      className={`${containerStyle} ${
        !hasMultipleSku ? 'single-sku-drop-down' : ''
      }`}
      onClick={() => {
        if (hasMultipleSku)
          showMultipleSkuModal({
            visible: true,
            data: { ...product, source },
          });
      }}
    >
      <div className="multiple-sku-bottom-sheet--info">
        <span className={quantityTextStyle}>{sku?.quantity}</span>
        {showSubtext && sku?.subText && (
          <span className={productSubTextStyle}>{sku?.subText}</span>
        )}
      </div>
      {hasMultipleSku && (
        <Icon
          class={`icon-multiple-sku-dropdown ${
            rightArrow ? 'multiple-sku-bottom-sheet--right-arrow' : ''
          }`}
          size={iconSize}
        />
      )}
    </div>
  );
};

export default MultipleSkuDropDown;
